import { useEffect, useState, forwardRef } from 'react';
import { PropfitAvatar } from './PropfitAvatar';

interface ChatBubbleProps {
  from: 'bot' | 'user';
  children: React.ReactNode;
}

export const ChatBubble = forwardRef<HTMLDivElement, ChatBubbleProps>(
  function ChatBubble({ from, children }, ref) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
      const t = setTimeout(() => setVisible(true), 20);
      return () => clearTimeout(t);
    }, []);

    return (
      <div
        ref={ref}
        className={
          from === 'bot'
            ? 'flex items-end gap-2'
            : 'flex items-end justify-end gap-2'
        }
      >
        {from === 'bot' && (
          <PropfitAvatar
            className={
              'transform-gpu transition-all duration-300 will-change-transform' +
              (visible
                ? ' translate-x-0 scale-100 opacity-100'
                : ' -translate-x-2 scale-95 opacity-0')
            }
          />
        )}
        <div
          className={
            'max-w-[80%] transform-gpu rounded-xl rounded-bl-none px-4 py-2.5 shadow-sm transition-all duration-300 will-change-transform ' +
            (from === 'bot'
              ? ' bg-brand text-white'
              : ' bg-grey-10 text-grey-90') +
            (visible
              ? ' translate-y-0 scale-100 opacity-100'
              : from === 'bot'
              ? ' -translate-x-2 translate-y-1 scale-95 opacity-0'
              : ' translate-x-2 translate-y-1 scale-95 opacity-0')
          }
        >
          <div className='text-sm leading-relaxed'>{children}</div>
        </div>
      </div>
    );
  }
);
